import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { ContactPointOrderingEnum, FoundingMapService } from '@ui/shared/util-api';
import { FoundingMapItemModel } from '../../entities/founding-map-item.model';
import type { FoundingMapFilter } from '../../types/founding-map-filters';
import { FoundingDataType } from '../../enums/founding-data-type';
import { FoundingMapItemMapper } from '../../mappers/founding-map-item.mapper';
import { toRequestQuery } from '@ui/shared/util-filter';

@Injectable({ providedIn: 'root' })
export class FoundingContactPointMapDataService extends MapDataService<FoundingMapItemModel, FoundingMapFilter> {
    protected _api = inject(FoundingMapService);

    public getData$(filter: FoundingMapFilter): Observable<Array<FoundingMapItemModel>> {
        if (filter.type && filter.type !== FoundingDataType.ContactPoint) {
            return of([]);
        }

        if (filter.sector !== null && typeof filter.sector !== 'undefined') {
            return of([]);
        }

        return this._api.getAllContactPoints({
            nameContains: typeof filter.search === 'string' ? filter.search : null,
            targetGroupIds: toRequestQuery(filter.targetGroup),
            order: [ContactPointOrderingEnum.Name],
        })
            .pipe(map(response => response.data.map(dto => FoundingMapItemMapper.fromContactPointDto(dto))));
    }
}
